module.exports = __webpack_public_path__ + "static/img/title.5ba1c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/title.png
// module id = dGZh
// module chunks = 3